import { Nilable } from "@shared/utils";

export interface IGrupoUsuariosActivosDTO {
    actives: number;
    actives_24_hours: number;
    count: number;
}

export class GrupoUsuariosActivosDTO {
    public activos = 0;
    public activos24hs = 0;
    public cantidadTotal = 0;

    constructor(json: Nilable<Partial<IGrupoUsuariosActivosDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IGrupoUsuariosActivosDTO>) {
        if (json.actives != null) {
            this.activos = json.actives;
        }
        if (json.actives_24_hours != null) {
            this.activos24hs = json.actives_24_hours;
        }
        if (json.count != null) {
            this.cantidadTotal = json.count;
        }
    }

    public toJSON(): IGrupoUsuariosActivosDTO {
        return {
            actives: this.activos,
            actives_24_hours: this.activos24hs,
            count: this.cantidadTotal
        };
    }
}
